import { coreService } from "../../../../services/coreService";
import { SecondArgumentType } from "../../../../types/ArgumentTypes";
import { buildQuery } from "../../../../lib/network";

export type PatchInspectionAddressReqBody = SecondArgumentType<typeof coreService.inspectionsAddressPartialUpdate>;
export type PatchInspectionAddressReqBodyState = PatchInspectionAddressReqBody["data"]["address"]["state"];
export const patchInspectionAddress = (headers: any, id: number) => (body: PatchInspectionAddressReqBody) => {
  return buildQuery(coreService.inspectionsAddressPartialUpdate(id, body, { headers }), (response) => {
    return response.data;
  });
};
